<template>
  <div>
    <div
      :class="[
        istransparent ? 'header-info-nav' : 'header-info-nav-notransparent',
        {
          'header-info-nav-fix': navBarFixed,
          'padding-top': $isInApp,
        },
      ]"
    >
      <div
        :class="[
          'header-info-nav__left',
          {
            'header-info-nav__left_two': !istransparent,
            'header-info-nav__left_wihte': isHomePage,
          },
        ]"
        @click.stop="goBack()"
      />
      <div
        v-if="title"
        :class="[
          fontSize,
          istransparent
            ? 'header-info-nav__text'
            : 'header-info-nav-notransparent__text',
        ]"
      >
        {{ title }}
      </div>
      <div
        v-if="istransparent"
        :class="[
          'header-info-nav__right',
          {
            'header-info-nav__right_wihte': isHomePage,
          },
        ]"
        @click.stop="sharePage"
      ></div>
    </div>
  </div>
</template>

<script>
import WXJsBridge from "@xes/wxjsbridge";
import { appendStuCourseIds } from "@/common/script/log-helper";
export default {
  name: "header-nav",
  props: {
    data: {
      type: Object,
      default: null,
    },
    shareScence: {
      type: Number,
      default: 31,
    },
    noHeaderModule: {
      type: Boolean,
      default: false,
    },
    isHomePage: {
      type: Boolean,
      default: false,
    },
    fuck: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: String,
      default: "small",
    },
    // 页面标题 & 网页标题 （分享标题）
    cardTitle: {
      type: String,
      default: "学而思网校",
    },
    // 分享描述
    cardDescription: {
      type: String,
      default: "受益一生的能力",
    },
    istransparent: {
      type: Boolean,
      default: true,
    },
    // info: {isIndexHead: boolean, userid: ''} isIndexHead一级页面还是切换账号页面，用于埋点数据不同
    info: {
      type: Object,
      default: null,
    },
    navBarFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {
    if (this.$isInApp) {
      // 隐藏端上头
      window?.xesApp?.setTitleVisible(0);
    }
    if (!this.$isInApp) document.title = this.cardTitle;
  },
  computed: {
    title() {
      if (this.noHeaderModule) {
        return this.cardTitle;
      } else {
        return "";
      }
    },
  },
  methods: {
    goBack() {
      this.$store.commit("setIsLoad", false);
      this.$store.commit("setIsGoUrl", false);
      if (this.$isInApp) {
        try {
          window?.xesApp?.goBack();
        } catch (e) {
          console.log("call native back error", e, e.message);
          window.history.go(-1);
        }
      } else {
        window.history.go(-1);
      }
      this.handleBackPoint();
    },
    // app 中分享
    sharePage() {
      this.$emit("share");
      const shareUrl = window.location.href;
      // 分享按钮的逻辑
      WXJsBridge &&
        WXJsBridge.share({
          type: 1, // 1.网页，2大图，3小程序
          shareURL: shareUrl,
          isOneKeyShare: false,
          scence: 1567,
          title: this.cardTitle,
          describe: this.cardDescription,
        });
    },
    handleBackPoint() {
      if (this.istransparent) {
        window?.__XES_LOG__?.clickMsg({
          key: "click-goback",
          params: appendStuCourseIds({
            type: "changeCourseIndex",
            user_id: this.info.userid || "",
          }),
        });
      } else {
        if (this.info.isIndexHead) {
          window?.__XES_LOG__?.clickMsg({
            key: "click-goback",
            params: appendStuCourseIds({
              type: "index",
              user_id: this.info.userid || "",
            }),
          });
        } else {
          window?.__XES_LOG__?.clickMsg({
            key: "click-goback",
            params: appendStuCourseIds({
              type: "changeUrse",
              user_id: this.info.userid || "",
            }),
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.padding-top {
  padding-top: 44px;
}
/* 固定导航 */
.header-info-nav-fix {
  position: fixed;
  top: 0;
  z-index: 999;
}

.header-info-nav {
  // position: fixed;
  // left: 0;
  // top: 0;
  // margin-top: -12px;
  //position: sticky;
  //top: 0;
  background-color: transparent;
  //margin-left: -12px;
  width: 100vw;
  height: 44px;
  transition: background-color 1s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  &__tag {
    display: flex;
    text-align: center;
    align-items: center;
    width: 156px;
    height: 28px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 14px;
    // opacity: 0.4;
    &_ares {
      width: 77px;
      height: 24px;
      border-radius: 14px;

      &_font {
        width: 39px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 18px;
      }
    }
  }

  &__fixed {
    display: flex;
    text-align: center;
    align-items: center;

    &_ares {
      &_font {
        width: 57px;
        height: 26px;
        font-size: 19px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 26px;
        white-space: nowrap;
      }

      &_select {
        position: relative;
        top: 10px;
        margin: 0 auto;
        width: 20px;
        height: 3px;
        background: #eb002a;
        border-radius: 2px;
      }
    }
  }

  &__left {
    margin-left: 16px;
    // margin-left: 16px;
    width: 24px;
    height: 24px;
    background-image: url("https://editor.xesimg.com/tailor/resource/back-black-1720434616425.png");
    background-size: cover;
    background-repeat: no-repeat;

    &_two {
      margin-left: 12px;
      z-index: 1;
    }
  }

  &__left_wihte {
    background-image: url("https://editor.xesimg.com/tailor/resource/back-icon-1720433834849.png");
  }

  &__right {
    margin-right: 16px;
    width: 24px;
    height: 24px;
    background-image: url("https://editor.xesimg.com/tailor/resource/share-black-1720434616424.png");
    background-size: cover;
    background-repeat: no-repeat;
  }

  &__right_wihte {
    background-image: url("https://editor.xesimg.com/tailor/resource/share-icon-1720433834849.png");
  }

  &__text {
    margin: 0 auto;

    &.small {
      font-size: 34px;
    }

    &.big {
      font-size: 18px;
    }
  }
}

.header-info-nav-notransparent {
  //   position: fixed;
  //   top: 0;
  width: 375px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  background: #ffffff;

  //   &__left {
  //     margin-left: 32px;
  //     width: 48px;
  //     height: 48px;
  //     background-image: url("https://editor.xesimg.com/tailor/resource/back-black-1720434616425.png");
  //     background-size: cover;
  //     background-repeat: no-repeat;
  //   }

  &__text {
    flex: 1;
    margin-left: -24px;

    color: #333;
    text-align: center;
    font-family: PingFang SC;
    font-size: 19px;
    font-weight: 600;

    &.small {
      font-size: 28px;
    }

    &.big {
      font-size: 18px;
    }
  }

  &__right {
    margin-right: 32px;
    width: 48px;
    height: 48px;
  }
}
</style>
